// First Updated Date / Response Time: how long a lead waited before the client's own team
// first worked it (first remark, status change or field edit). Ranges match the backend
// filter in leads_enhanced.controller.js (getEnhancedLeadsGrouped).
export const RESPONSE_TIME_OPTIONS = [
    { opt_id: 'within_1h', opt_name: 'Within 1 hour' },
    { opt_id: '1h_to_4h', opt_name: '1 to 4 hours' },
    { opt_id: '4h_to_24h', opt_name: '4 to 24 hours' },
    { opt_id: 'over_24h', opt_name: 'Over 24 hours' },
    { opt_id: 'not_updated', opt_name: 'Not updated yet' },
];

// e.g. "45m", "3h 20m", "2d 4h"; "Not updated yet" when nobody has worked the lead
export const formatResponseTime = (createdDate?: string | null, firstUpdatedDate?: string | null): string => {
    if (!firstUpdatedDate) return 'Not updated yet';
    if (!createdDate) return '-';
    const minutes = Math.max(0, Math.floor((new Date(firstUpdatedDate).getTime() - new Date(createdDate).getTime()) / 60000));
    if (isNaN(minutes)) return '-';
    const days = Math.floor(minutes / 1440);
    const hours = Math.floor((minutes % 1440) / 60);
    if (days > 0) return `${days}d ${hours}h`;
    if (hours > 0) return `${hours}h ${minutes % 60}m`;
    return `${minutes}m`;
};
